import React from 'react';

import './mobileHomePaciente.scss';

export const MobileHomePaciente = () => {
    return (
        <>
            <div className='mobile-paciente-container'>
                <div className='mobile-paciente-banner'>   
                    <div className='mobile-paciente-sistema'>
                        <div className='mobile-paciente-sistema-titulo'>
                            Bienvenido a casa,<br />bienvenido a Nutrihome<br />
                        </div>
                        <div className='mobile-paciente-sistema-texto'>
                            Nutrición clínica domiciliaria y cuidados<br />paliativos domiciliarios
                        </div>
                    </div>
                </div>

                <div className='mobile-paciente-titulo'>
                    Acción Integral y Centrada<br />en el Paciente
                </div>
                <div className='mobile-paciente-texto'>
                    Cuando un paciente requiere soporte nutricional oral, enteral o parenteral de forma transitoria o definitiva y no existen otros motivos para que permanezca hospitalizado, este tratamiento debe realizarse en su domicilio.En Nutrihome, nos especializamos en Soporte Nutricional y Cuidados Paliativos Domiciliarios, cubriendo todos los aspectos de la práctica a través de nuestros equipos de profesionales especializados.
                </div>

                <div className='mobile-paciente-objetivos'>
                    <div className='mobile-paciente-objetivos-titulo'>
                        Objetivos asistenciales<br /> de Nutrihome
                    </div>
                    <div className='mobile-paciente-objetivos-texto'>
                        Facilitar y acompañar en la transición del paciente del hospital al domicilio.
                        <br /><br />
                        Prevenir complicaciones y garantizar así una mayor seguridad del tratamiento.
                        <br /><br />
                        Mejoramos la calidad de vida de los pacientes que requieren cuidados paliativos en su propio domicilio.
                        <br /><br />
                        Consolidar la autonomía del paciente en la gestión de su tratamiento.
                    </div>
                </div>

                <div className='mobile-paciente-profesionales'>
                    <div className='mobile-paciente-profesionales-titulo'>
                        Conocé nuestros<br />servicios, visítanos
                    </div>
                    <div className='home-paciente-texto'>
                        <a href="https://www.carehome.com.ar" style={{ color: 'white', textDecoration: 'underline'}} target='_blank' title='Ir a la página de Carehome'>www.carehome.com.ar</a>
                    </div>
                    <div className='home-paciente-texto'>
                        <a href="https://www.nutrihome.com.ar" style={{ color: 'white', textDecoration: 'underline'}} target='_blank' title='Ir a la página de Nutrihome'>www.nutrihome.com.ar</a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MobileHomePaciente;